export * from './lib/home/home.component';
export { HomeComponent as InboxComponent } from './lib/home/home.component';
export * from './lib/services/home-data.service';
export * from './lib/state/workitems.actions';
export * from './lib/state/workitems.reducer';
export * from './lib/state/workitems.effects';

import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import * as fromWorkitems from './lib/state/workitems.reducer';
import { WorkitemsEffects } from './lib/state/workitems.effects';

export function provideWorkitemsFeature() {
  return [
    provideState(fromWorkitems.workitemsFeatureKey, fromWorkitems.workitemsFeature.reducer),
    provideEffects([WorkitemsEffects]),
  ];
}
